import React from 'react';
import { Link } from 'react-router-dom';

const BRAND = {
  teal: '#75B9BE',
  cream: '#FDF6EC',
  charcoal: '#2D4042',
  coral: '#FF7F50',
  white: '#FFFFFF',
  muted: '#5D7375'
};

const moduleCardStyle = {
  background: BRAND.white,
  border: `2px solid ${BRAND.charcoal}`,
  borderRadius: '20px',
  boxShadow: '6px 6px 0 rgba(45, 64, 66, 0.12)',
  color: BRAND.charcoal,
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  minHeight: '190px',
  padding: '30px',
  textDecoration: 'none',
  transition: 'transform 0.18s ease, box-shadow 0.18s ease'
};

const JCQHub = () => (
  <div style={{ background: BRAND.cream, color: BRAND.charcoal, fontFamily: "'Inter', sans-serif", minHeight: '100vh', padding: '44px 20px' }}>
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Nunito:wght@700;800&display=swap');
      .jcq-module-card:hover { transform: translateY(-3px); box-shadow: 8px 8px 0 rgba(45, 64, 66, 0.16); }
      .jcq-back-link:hover { color: ${BRAND.coral}; }
      h1, h2 { font-family: 'Nunito', sans-serif; }
    `}</style>

    <main style={{ maxWidth: '1100px', margin: '0 auto' }}>
      <Link className="jcq-back-link" to="/dashboard" style={{ color: BRAND.charcoal, display: 'inline-block', fontWeight: 800, marginBottom: '24px', textDecoration: 'none' }}>
        ← Back to dashboard
      </Link>

      <section style={{ alignItems: 'flex-start', display: 'flex', justifyContent: 'space-between', gap: '24px', marginBottom: '34px', flexWrap: 'wrap' }}>
        <div>
          <p style={{ color: BRAND.coral, fontFamily: 'Nunito, sans-serif', fontSize: '0.9rem', fontWeight: 800, letterSpacing: '0.08em', margin: '0 0 8px', textTransform: 'uppercase' }}>
            Evidence hub
          </p>
          <h1 style={{ fontSize: '2.6rem', lineHeight: 1.05, margin: 0 }}>JCQ Access Arrangements</h1>
          <p style={{ color: BRAND.muted, fontSize: '1.05rem', margin: '14px 0 0', maxWidth: '650px' }}>
            Generate and review evidence for access arrangement workflows from existing ClassCompass student data.
          </p>
        </div>
      </section>

      <section style={{ display: 'grid', gap: '24px', gridTemplateColumns: 'repeat(2, minmax(280px, 1fr))' }}>
        <Link className="jcq-module-card" to="/jcq/extra-time-test" style={moduleCardStyle}>
          <span style={{ alignSelf: 'flex-start', background: 'rgba(255, 127, 80, 0.14)', borderRadius: '999px', color: BRAND.coral, fontFamily: 'Nunito, sans-serif', fontSize: '0.8rem', fontWeight: 800, padding: '6px 12px' }}>
            Module 1
          </span>
          <h2 style={{ fontSize: '1.65rem', margin: '8px 0 0' }}>Extra Time Test</h2>
          <p style={{ color: BRAND.muted, fontSize: '1rem', lineHeight: 1.5, margin: 0 }}>Generate compliant 25% extra time evidence.</p>
        </Link>

        <Link className="jcq-module-card" to="/jcq/nnow" style={moduleCardStyle}>
          <span style={{ alignSelf: 'flex-start', background: 'rgba(117, 185, 190, 0.18)', borderRadius: '999px', color: BRAND.teal, fontFamily: 'Nunito, sans-serif', fontSize: '0.8rem', fontWeight: 800, padding: '6px 12px' }}>
            Module 2
          </span>
          <h2 style={{ fontSize: '1.65rem', margin: '8px 0 0' }}>Form 8/Form 9 Part 1</h2>
          <p style={{ color: BRAND.muted, fontSize: '1rem', lineHeight: 1.5, margin: 0 }}>View longitudinal evidence of student scaffolding and speed.</p>
        </Link>

        <Link className="jcq-module-card" to="/jcq/student-checklist" style={moduleCardStyle}>
          <span style={{ alignSelf: 'flex-start', background: 'rgba(45, 64, 66, 0.1)', borderRadius: '999px', color: BRAND.charcoal, fontFamily: 'Nunito, sans-serif', fontSize: '0.8rem', fontWeight: 800, padding: '6px 12px' }}>
            Module 3
          </span>
          <h2 style={{ fontSize: '1.65rem', margin: '8px 0 0' }}>JCQ Student Checklist</h2>
          <p style={{ color: BRAND.muted, fontSize: '1rem', lineHeight: 1.5, margin: 0 }}>Track access arrangement steps for each student.</p>
        </Link>
      </section>
    </main>
  </div>
);

export default JCQHub;
